module.exports = __webpack_public_path__ + "img/logo-apple-watch.09e3085a.png";